import React from 'react'
import Heading from 'LuxKit/Typography/Heading'
import SmallToggleButton from 'LuxKit/Button/SmallToggleButton'
import styled from 'styled-components'

const HeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

interface Props {
  disableExpand?: boolean;
  expandDirection: 'up' | 'down';
  minimised: boolean;
  onToggleMinimise: () => void;
  title?: string;
}

const YouMayAlsoLikeHeader = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { onToggleMinimise, expandDirection, minimised, disableExpand, title } = props
  const toggledOn = expandDirection === 'up' ? minimised : !minimised
  const headingTitle = title || 'Exclusive hotel offers you may also like'
  return (
    <HeadingWrapper ref={ref}>
      <Heading variant="heading6">{headingTitle}</Heading>
      {!disableExpand && <SmallToggleButton on={toggledOn} onClick={onToggleMinimise} iconPosition="start">
        {minimised ? 'Show' : 'Hide'}
      </SmallToggleButton>}
    </HeadingWrapper>
  )
})

export default YouMayAlsoLikeHeader
